import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import services, { GetMasterBranchPayload, MasterBranch } from 'services/branch'
import { STALE_TIME } from 'utils/constants'

const queryKeys = {
  item: 'master-branch-item',
}

const useItem = (payload: GetMasterBranchPayload, options?: AppQueryOptions<MasterBranch>) =>
  useAppQuery([queryKeys.item, payload], () => services.getMasterBranch(payload), {
    staleTime: STALE_TIME.masterSetting,
    enabled: Boolean(payload?.branch_id),
    ...options,
  })

export type MasterBranchType = MasterBranch

export default {
  useItem,
}
